import { getGuid } from 'owa-guid';
import type { AugloopSession } from '../schema/AugloopSession';

export function createAugloopSession(): AugloopSession {
    return {
        sessionId: getGuid(),
    };
}
